import { cn } from '@/lib/utils/helpers'

const STYLES: Record<string, string> = {
  AUTO_MAPPED: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  WOULD_AUTO_MAP: 'bg-sky-50 text-sky-700 border-sky-200',
  MANUAL_REVIEW: 'bg-amber-50 text-amber-700 border-amber-200',
  UNMATCHABLE: 'bg-slate-100 text-slate-700 border-slate-200',
  FAILED: 'bg-rose-50 text-rose-700 border-rose-200',
  MANUALLY_MAPPED: 'bg-indigo-50 text-indigo-700 border-indigo-200',
  PENDING: 'bg-white text-slate-600 border-slate-200',
  ENABLED: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  SHADOW: 'bg-amber-50 text-amber-700 border-amber-200',
  DISABLED: 'bg-rose-50 text-rose-700 border-rose-200',
  COMPLETED: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  RUNNING: 'bg-sky-50 text-sky-700 border-sky-200',
  PARTIAL: 'bg-amber-50 text-amber-700 border-amber-200',
  NOT_SCHEDULED: 'bg-slate-100 text-slate-600 border-slate-200',
}

const STATUS_LABELS: Record<string, string> = {
  UNMATCHABLE: 'Permanent skipped',
}

export function matchingStatusLabel(value?: string | null): string {
  const status = String(value || 'PENDING').toUpperCase()
  return STATUS_LABELS[status] || status.replace(/_/g, ' ').toLowerCase()
}

export function MatchStatusBadge({ value }: { value?: string | null }) {
  const status = String(value || 'PENDING').toUpperCase()
  return (
    <span
      className={cn(
        'inline-flex rounded-full border px-2.5 py-0.5 text-xs font-semibold capitalize',
        STYLES[status] || STYLES.PENDING,
      )}
    >
      {matchingStatusLabel(status)}
    </span>
  )
}
